import Vue from 'vue'
import domUtils from 'util/dom-utils'
import { localizedPercentage } from 'util/localization-utils'

import withRender from './summary-dim-range.html'
import './summary-dim.scss'
import './summary-dim-range.scss'

export default withRender(Vue.extend({

  data() { return { dotSize: 0 } },
  props: {
    averageRating: {
      type: Number,
      default: 0.0
    },
    headingLevel: { type: Number, default: 3 },
    showMiddleLabel: Boolean,
    values: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    description() {
      return this.$msg('summaryRange.desc', [
        localizedPercentage(this.percentage, 0),
        this.valueLabels[0],
        this.valueLabels[1]
      ])
    },
    dotPositionPercentage() {
      // -1 on the values since it is a zero-based value
      const dotAdjustment = Math.round(this.dotSize * this.percentage)
      return `calc(${(this.percentage * 100).toFixed(1)}% - ${dotAdjustment}px)`
    },
    percentage() {
      return this.averageRating / (this.values.length - 1)
    },
    valueLabels() {
      return this.values.filter((def, i) => {
        // if first or last label
        if (i === 0 || i === this.values.length - 1) {
          return true
        } else if (this.showMiddleLabel && i === (this.values.length === 3 ? 1 : 2)) {
          // middle label is index 1 if there are 3, index 2 if there are 5
          return true
        }
        return false
      }).map(def => def.label)
    }
  },
  mounted() {
    domUtils.whenRefIsVisible(this.$refs, 'dot').then(() => {
      this.dotSize = this.$refs.dot.offsetWidth
    }).catch(() => {
      // when initially hidden on page (e.g. under a tab), offsetWidth is 0.  This is a fallback
      // to the px equivalent to the rem(10) it is set to in css
      this.dotSize = 10
    })
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-summary/summary-dim-range.ts